import { type PublicEventContentObject, isProgramEventAfterOpenToJoin } from 'models';
import { Alert } from 'ui';

type P = {
  eventContentObject: PublicEventContentObject;
};

const ProgramEventJoinStatusAlerts = ({ eventContentObject }: P) => {
  if (isProgramEventAfterOpenToJoin(eventContentObject.event)) {
    return <Alert title="This event has ended" />;
  }

  return <Alert title="You must be logged in to enter this event" />;
};

export default ProgramEventJoinStatusAlerts;
